import { render, staticRenderFns } from "./handoverRecord.vue?vue&type=template&id=41e06e62&scoped=true&"
import script from "./handoverRecord.vue?vue&type=script&lang=js&"
export * from "./handoverRecord.vue?vue&type=script&lang=js&"
import style0 from "./handoverRecord.vue?vue&type=style&index=0&id=41e06e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e06e62",
  null
  
)

export default component.exports